/**
 * CASH_SPONSOR 뽑기권의 종류를 분류해주는 타입. STANDALONE 에서는 내려오지 않음
 * 레퍼런스(api): https://github.kakaocorp.com/kakaopage/api/blob/c7b2307cf7f9761b8db7501e31c75d383a2f43a4/api/src/main/java/com/kakaopage/api/model/GotchaMainResponse.java#L51
 */
export enum GotchaEntryTypeVo {
  None = 'NONE',
  // 일반적인 캐시스폰서 광고 뽑기권
  CashSponsorAd = 'AD',
  // 특정 상황에 쓰이는 쿠폰번호 입력 창이 있는 뽑기권
  Redeem = 'REDEEM',
  Direct = 'DIRECT',
}
